import config from '~/config/config';

export default function({ store, error }) {
    const activeSite = store.getters['sites/activeSite'];

    if (!config.mijnomgeving.enabled.includes(activeSite)) {
        return error({ statusCode: 404, message: 'error.message.404' });
    }
}
